import { useEffect, useRef } from 'react';
import { scrollIntoView } from '@helpers/dom';
import { noop } from '@helpers/misc';
import { SelectInputValue } from '../types';
import { SelectInputOptionsStyled, SelectInputOptionStyled } from './styled';
import { SelectInputOptionsProps } from './types';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export function SelectInputOptions<V extends SelectInputValue>(props: SelectInputOptionsProps<V>): React.ReactElement<SelectInputOptionsProps<V>> {
  const {
    options,
    //
    selectedIndex,
    hoveredIndex,
    onSelect,
    onHover
  } = props;
  const selectedOptionRef = useRef<HTMLLIElement>(null);
  useEffect(() => {
    if (!selectedOptionRef.current) {
      return;
    }
    scrollIntoView(selectedOptionRef.current, {
      behavior: 'auto',
      block: 'nearest'
    });
  }, []);
  return _jsx(SelectInputOptionsStyled, {
    children: options.map((option, index) => {
      const click: React.MouseEventHandler<HTMLLIElement> = event => {
        onSelect(option.value, event);
      };
      const hover = () => {
        onHover(index);
      };
      return _jsx(SelectInputOptionStyled //
      , {
        ref: index === selectedIndex //
        ? selectedOptionRef : undefined,
        active: index === selectedIndex,
        hovered: index === hoveredIndex,
        onClick: click,
        onKeyDown: noop,
        onMouseEnter: hover,
        children: option.label
      }, String(option.value));
    })
  });
}